import { client } from 'src/enviroment/api/axios'
import { useQuery } from '@tanstack/react-query'
import { useTenantStore } from 'src/enviroment/store/tenentStore'
import { Query } from '../index'

export interface GeocodingFeature {
  id: string
  place_name: string
  center: [number, number]
  place_type: string[]
  bbox?: [number, number, number, number]
}

export const mapboxRouterKeys = {
  geocode: 'mapbox.geocode',
} as const

// Narrow geocode results to a single Mapbox place type (e.g. country-only picker)
export type GeocodePlaceType = 'country' | 'region' | 'place' | 'locality'

export const mapboxRouter = {
  geocode: {
    useQuery: (q: string, types?: GeocodePlaceType, opts?: Query<GeocodingFeature[]>) => {
      const tenantId = useTenantStore((state) => state.currentTenant?.id)

      return useQuery<GeocodingFeature[]>({
        queryKey: [mapboxRouterKeys.geocode, tenantId, q, types],
        queryFn: async () => {
          const response = await client.get<GeocodingFeature[]>(`/tenants/${tenantId}/mapbox/search:geocode`, {
            params: { q, ...(types ? { types } : {}) },
          })
          return response.data
        },
        ...opts,
        enabled: Boolean(tenantId) && q.trim().length > 2 && (opts?.enabled ?? true),
      })
    },
  },
}
